// extracted by mini-css-extract-plugin
module.exports = {"dots":"DotsAnimation_dots__DhVAx","fadeIn":"DotsAnimation_fadeIn__Gxh2A"};